<template>
    <div class="flex overflow-hidden">
        <div class="flex w-10 shrink-0 items-start justify-center">
            <icon icon="cil-check-circle" class="h-[22px]" />
        </div>
        <div class="overflow-hidden">
            <div>
                <b class="block truncate">{{ trans('notification.user.access_revoked.title') }}</b>
            </div>
            <small class="line-clamp-2 block text-wrap text-gray-500">{{
                trans('notification.user.access_revoked.description', {
                    name: props.notification.payload.name,
                })
            }}</small>
        </div>
    </div>
</template>
<script setup>
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    notification: {
        type: Object,
        required: true,
    },
});
</script>
